import React from 'react';

import { DatetimeFormatType, TypeOfDate } from 'app/lib/datetime/types';

import Datetime from 'app/design-system/components/Datetime';
import { replacingHyphenOnDash } from 'app/lib/replaceDashSymbol';
import { MatchCenterLink } from 'app/modules/Betting';

import styles from '../Announcement.module.scss';

type AnnouncementItemProps = {
  matchName: string;
  startDate?: string;
  matchId?: number;
};

export function AnnouncementItem({ matchName, matchId, startDate }: AnnouncementItemProps) {
  const replacedMatchName = replacingHyphenOnDash(matchName);

  return (
    <li className={styles.announcementItem}>
      {matchId && (
        <MatchCenterLink matchId={matchId}
                         className={styles.announcementLink}>
          {replacedMatchName}
        </MatchCenterLink>
      )}
      <div className={styles.announcementTime}>
        {startDate
          ? (
            <Datetime value={startDate}
                      format={DatetimeFormatType.FRIENDLY}
                      typeOfDate={TypeOfDate.MATCH_DATE} />
          )
          : '––'}
      </div>
    </li>
  );
}
